import { GenIcon } from '../helpers/IconBase.es.js';

const LocationPickerColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 20 20", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_15304_4436)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M15.8332 18.3334H13.5757L16.4815 15.6484C20.0614 12.0686 20.0615 6.26464 16.4817 2.68476C12.9019 -0.895123 7.09798 -0.895161 3.5181 2.68457C-0.0617871 6.26429 -0.0618654 12.0684 3.5179 15.6482C3.52575 15.6561 6.42403 18.3334 6.42403 18.3334H4.16653C3.7063 18.3334 3.33321 18.7065 3.33321 19.1667C3.33321 19.6269 3.7063 20 4.16653 20H15.8332C16.2935 20 16.6665 19.6269 16.6665 19.1667C16.6665 18.7065 16.2934 18.3334 15.8332 18.3334ZM4.69653 3.86339C7.61903 0.927769 12.368 0.917143 15.3036 3.83964C18.2392 6.76214 18.2499 11.5111 15.3274 14.4467L12.0065 17.5142C10.8731 18.5825 9.10161 18.5763 7.97571 17.5L4.69653 14.47C1.77212 11.5392 1.77216 6.79425 4.69653 3.86339Z",
              fill: "black",
              fillOpacity: "0.88"
            }
          },
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M11.1181 13.0717C10.7707 13.2445 10.3879 13.3341 9.99982 13.3334C9.61166 13.3336 9.22877 13.2435 8.8815 13.0701L7.21482 12.2367C6.36584 11.8152 5.8301 10.9479 5.83314 10.0001V7.52756C5.83037 6.57978 6.3665 5.71275 7.21564 5.29173L8.88232 4.45842C9.5865 4.10842 10.414 4.10842 11.1181 4.45842L12.7848 5.29173C13.6337 5.71298 14.1694 6.57994 14.1665 7.52756V10.0001C14.1702 10.9485 13.6343 11.8166 12.7848 12.2384L11.1181 13.0717ZM7.49982 10.0001V7.52756C7.50115 7.44256 7.51549 7.35822 7.54232 7.27756L9.359 8.18588C9.76244 8.38752 10.2372 8.38752 10.6407 8.18588L12.4574 7.27756C12.4842 7.35822 12.4985 7.44256 12.4999 7.52756V10.0001C12.5012 10.3162 12.3224 10.6056 12.039 10.7459L10.3724 11.5792C10.1374 11.6955 9.86154 11.6955 9.62654 11.5792L7.95986 10.7459C7.67678 10.6054 7.49834 10.3161 7.49982 10.0001Z",
              fill: "#00973C"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_15304_4436" },
            child: [
              {
                tag: "rect",
                attr: { width: "20", height: "20", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { LocationPickerColored };
